<script setup lang="ts">
import IconBase from '../IconBase.vue';
</script>

<template>
  <IconBase v-bind="$attrs">
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.7758 14.4736C29.0687 14.7665 29.0687 15.2413 28.7758 15.5342L17.5302 26.7798C17.2373 27.0727 16.7625 27.0727 16.4696 26.7798L11.2246 21.5348C10.9317 21.2419 10.9317 20.767 11.2246 20.4741C11.5174 20.1813 11.9923 20.1813 12.2852 20.4741L16.9999 25.1888L27.7152 14.4736C28.0081 14.1807 28.4829 14.1807 28.7758 14.4736Z"
        fill="currentColor"
      />
    </svg>
  </IconBase>
</template>
